window.vertiv = window.vertiv || {};
vertiv.storage = {
  set: function(name, value) {
    localStorage.setItem(`${name}`, JSON.stringify(value));
  },
  get: function(name) {
    const value = localStorage.getItem(`${name}`);
    try {
      return value ? JSON.parse(value) : null;
    } catch {
      return value; // Fallback for non-JSON strings
    }
  },
  remove: function(name) { 
    localStorage.removeItem(`${name}`);
  }
};